import { TopUpForm, TopUpFormConfig } from './TopUpForm'
import { useCreateOrgPayment } from '@/services/billing'
import { useGetOrgBalanceSummary } from '@/services/home'
import { School } from 'lucide-react'
import {
  OrgBalanceDetailsDialog,
  OrgBalanceDetailsDialogProps,
  UserBalanceDetailsDialogProps,
} from '@/components/balance-details-dialog'

export interface OrgTopUpFormProps {
  variant?: 'display-only' | 'full'
  onClose?: () => void
}

// Create a wrapper for org balance data to match the expected interface
const useOrgBalanceData = () => {
  return useGetOrgBalanceSummary()
}

const orgTopUpConfig: TopUpFormConfig = {
  useBalanceData: useOrgBalanceData,
  useCreatePayment: useCreateOrgPayment,
  icon: School,
  title: 'Organization Credits',
  loadingMessage: 'Loading organization balance...',
  errorMessagePrefix: 'Failed to load organization balance',
  noDataMessage: 'No organization balance data available',
  BalanceDetailsDialog: OrgBalanceDetailsDialog as React.ComponentType<{
    trigger: React.ReactNode
    data: OrgBalanceDetailsDialogProps | UserBalanceDetailsDialogProps
  }>,
}

export const OrgTopUpForm = ({
  variant = 'full',
  onClose,
}: OrgTopUpFormProps) => {
  return (
    <TopUpForm
      config={orgTopUpConfig}
      userId={0} // Not used for org balance
      variant={variant}
      onClose={onClose}
    />
  )
}
